"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const intl_1 = require("@kyruus/intl");
const react_1 = __importStar(require("react"));
const messages_1 = __importDefault(require("../../lib/messages"));
const banner_1 = __importDefault(require("@kyruus/banner"));
const profile_contact_1 = __importDefault(require("../ProfileContact/profile-contact"));
const location_address_1 = __importDefault(require("../ProviderLocations/location-address"));
const loaders_and_spinners_1 = require("@kyruus/loaders-and-spinners");
const styles_1 = require("./styles");
const formatWaitTime = (waitTimeInSeconds) => {
    const seconds = parseInt(waitTimeInSeconds, 10);
    if (isNaN(seconds) || seconds <= 59) {
        return (react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.estimatedWaitTimeMinutes, { values: { minutes: 0 } })));
    }
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    if (hours > 0 && minutes > 0) {
        return (react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.estimatedWaitTimeHoursAndMinutes, { values: { hours: hours, minutes: minutes } })));
    }
    if (hours > 0 && minutes === 0) {
        return (react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.estimatedWaitTimeHours, { values: { hours: hours } })));
    }
    if (minutes > 0 && hours === 0) {
        return (react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.estimatedWaitTimeMinutes, { values: { minutes: minutes } })));
    }
    return null;
};
function EstimatedWaitTimeSection({ provider, locations, config, track, getWaitTimeCallbackFunction = () => null, waitTimeMap }) {
    var _a, _b, _c, _d;
    const locationEhrId = (_b = (_a = locations === null || locations === void 0 ? void 0 : locations[0]) === null || _a === void 0 ? void 0 : _a.ehr_location_id) !== null && _b !== void 0 ? _b : '';
    const sourceSystem = (_d = (_c = locations === null || locations === void 0 ? void 0 : locations[0]) === null || _c === void 0 ? void 0 : _c.source_system) !== null && _d !== void 0 ? _d : '';
    const waitTime = waitTimeMap === null || waitTimeMap === void 0 ? void 0 : waitTimeMap[locationEhrId];
    const [waitTimeIsError, setWaitTimeIsError] = (0, react_1.useState)(false);
    const [waitTimeIsLoading, setWaitTimeIsLoading] = (0, react_1.useState)(true);
    (0, react_1.useEffect)(() => {
        const fetchWaitTime = () => __awaiter(this, void 0, void 0, function* () {
            if (locationEhrId && sourceSystem) {
                try {
                    yield getWaitTimeCallbackFunction(locationEhrId, sourceSystem);
                }
                catch (error) {
                    setWaitTimeIsError(true);
                }
                finally {
                    setWaitTimeIsLoading(false);
                }
            }
        });
        fetchWaitTime();
    }, []);
    return (react_1.default.createElement(styles_1.StyledWaitTimeSection, { "aria-labelledby": "EstimatedWaitTimeHeader", id: "estimated-wait-time-section" },
        react_1.default.createElement(styles_1.StyledWaitTimeHeader, { id: "EstimatedWaitTimeHeader" },
            react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.estimatedWaitTimeHeader))),
        waitTimeIsLoading ? (react_1.default.createElement(styles_1.StyledLoader, null,
            react_1.default.createElement(loaders_and_spinners_1.ShimmeringLoaderBar, { height: 30, width: 100 }),
            react_1.default.createElement(loaders_and_spinners_1.ShimmeringLoaderBar, { height: 30, width: 100 }))) : waitTimeIsError ? (react_1.default.createElement(styles_1.StyledErrorBlock, null,
            react_1.default.createElement(banner_1.default, { icon: "!", type: "warning" },
                react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.estimatedWaitTimeErrorMsg))))) : (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(styles_1.StyledWaitTime, { id: "wait-time-display" }, formatWaitTime(waitTime)),
            react_1.default.createElement(styles_1.StyledLocation, { id: "location-info" },
                react_1.default.createElement(styles_1.StyledLocationName, null, locations === null || locations === void 0 ? void 0 : locations[0].name),
                react_1.default.createElement(location_address_1.default, { location: locations === null || locations === void 0 ? void 0 : locations[0], config: config })),
            react_1.default.createElement(styles_1.StyledButtonLink, { href: provider.external_wait_time_url, mode: "primary" },
                react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.externalWaitTimeLinkText))))),
        react_1.default.createElement(profile_contact_1.default, { provider: provider, track: track })));
}
exports.default = EstimatedWaitTimeSection;
//# sourceMappingURL=EstimatedWaitTime.js.map